import React, { Component } from 'react';
import { Success } from '../GenericComponets/Success';
import { Danger } from '../GenericComponets/Danger';

export function PaymentResult(props) {
    return (
        <div>
            <div className="form-group">
                {
                    props.paymentSent == true &&
                    (props.paymentResult.executionStatus == "processed" || props.paymentResult.executionStatus == "processing" || props.paymentResult.executionStatus == "captured" ?
                    <Success>
                        The payment of €{props.paymentResult.amount} has been successfully processed.
                    </Success>
                    :
                    <Danger>
                        The payment of €{props.paymentResult.amount} was <strong>not</strong> processed.
                        {
                            (props.paymentResult.returnReasonDetailed != "" && props.paymentResult.returnReasonDetailed != null) &&
                                <div>{props.paymentResult.returnReasonDetailed}</div>
                        }
                    </Danger>)
                }
            </div>

            <div className="form-group">
                {
                    (!props.loading && props.hasError) &&
                    <Danger>
                        Oops! Something went wrong while trying to load your payment
                        confirmation. Don't worry, your payment hasn't been taken. Please 
                        try again or call <strong><a href="tel:019605983">01 960 5983</a></strong> if
                        the error persists.
                    </Danger>
                }
            </div>  
        </div>
    );
}

PaymentResult.defaultProps = {
    response: {},
    loading: false,
    hasError: false
}


// WEBPACK FOOTER //
// ./src/components/MakePayment/PaymentResult.js